import React from "react";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/avisoDePrivacidad/PageHeader";
import Information from "../components/avisoDePrivacidad/Information";

export default function Faq() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader HeaderTitle="Aviso de Privacidad" Parent="Inicio" PageTitle="Aviso de Privacidad" />
      <Information />
      <Footer />
    </Layout>
  );
}
